import { Api, getLogger, StringUtil } from '@mcleod/core';
import { AutogenLayoutDriverAcknowledge } from './autogen/AutogenLayoutDriverAcknowledge';
import { ClickEvent, Snackbar, TableRow, TableRowDisplayEvent } from "@mcleod/components";

const log = getLogger('portal-driver/DriverAcknowledge');

export class DriverAcknowledge extends AutogenLayoutDriverAcknowledge {

    override onLoad() {
        log.debug('Driver Acknowledge loaded');
    }

    buttonAcknowledgeOnClick(event: ClickEvent) {
        log.debug('Acknowledgment button clicked');
        const selectedRows = this.tableDriverAck.selectedRows;
        if (selectedRows.length === 0) {
            Snackbar.showSnackbar("Please select at least one row to update.");
            return;
        }
        selectedRows.forEach(row => this.updateAcknowledgeDate(row));
    }

    private updateAcknowledgeDate(row: TableRow): void {
        if (row?.data["acknowledge_date"] !== undefined && row?.data["acknowledge_date"] !== null) {
            Snackbar.showSnackbar("Load already acknowledged: " + row.data.get("order_id"));
            return;
        }

        Api.post("portal/driver/set-acknowledge",
            {
                movement_id: row.data.get("movement_id"),
                order_id: row.data.get("order_id")
            })
            .then(response => {
                log.debug('Acknowledgment date update for row:', row.data.get("order_id"));
                if (
                    Array.isArray(response.data) &&
                    response.data.length > 0 &&
                    response.data[0] &&
                    !StringUtil.isEmptyString(response.data[0].success)
                ) {

                    Snackbar.showSnackbar(response.data[0].success);
                    row.data.set("acknowledge_date", response.data[0].acknowledge_date || new Date());
                    row.backgroundColor = "success";
                    log.debug('Acknowledgment date updated successfully for order:', row.data.get("acknowledge_date"));
                } else {
                    Snackbar.showSnackbar("Failed to update acknowledgment date for order: " + row.data.get("order_id"));
                }
            })
            .catch(error => {
                log.error('Error updating acknowledgment date for row:', row.data.get("order_id"), error);
                Snackbar.showSnackbar("An error occurred while updating acknowledgment date for order: " + row.data.get("order_id"));
            });
    }

    buttonRefreshOnClick(event: ClickEvent) {
        log.debug('Refresh button clicked');
        this.mainDataSource.search();
    }

    /** This is an event handler for the onRowDisplay event of tableDriverAck.  */
    tableDriverAckOnRowDisplay(event: TableRowDisplayEvent) {
        const row = event.getTableRow();
        if (row?.data?.data["acknowledge_date"] !== undefined && row?.data?.data["acknowledge_date"] !== null) {
            row.backgroundColor = "success";
        }
    }
}
